import React, {useContext} from 'react';
import {AppCtx} from "../../../AppCtx";
import {IconUsers} from '../../../shared/components/HosannaIcons';
import {ThemeContext} from "../../../ThemeContext";

export default () => {
  const {isCommonSessionEnabled, setIsCommonSessionEnabled} = useContext(AppCtx);
  const {theme} = useContext(ThemeContext);
  
  return <div onClick={()=>setIsCommonSessionEnabled(!isCommonSessionEnabled)}
              style={{
                cursor:'pointer',
                borderRadius:'30%',
                padding:'5px',
                backgroundColor: isCommonSessionEnabled ? 
                  'var(--active-item-bg-color)' : 
                  'transparent'
              }}
              role="button" tabIndex={0}
              aria-label={isCommonSessionEnabled ? "Wyłącz wspólną sesję" : "Włącz wspólną sesję"}
              title={isCommonSessionEnabled ? "Wyłącz wspólną sesję" : "Włącz wspólną sesję"}>
    <IconUsers style={{
      color: isCommonSessionEnabled ? 
        'var(--active-item-text-color)' : 
        (theme === 'dark' ? 'var(--icon-color-dark)' : 'var(--menu-icon-inactive-color)')
    }}/>
  </div>;
};
